import React from "react";

/**
 * Proposals: a presentation board with a rising line, the pitch you put in
 * front of a prospect. Proposals used the Quotes icon until 2026-10-01. Same
 * props and sizing contract as the other menu icons (18 x 18 viewBox, colour
 * from `fill`), drawn as strokes in that colour.
 */
export default function ProposalsIcon(props?: any) {
  const svgStyles: any = {
    width: props?.width ? props.width : null,
    height: props?.height ? props.height : null,
    fill: props?.fill ? props.fill : null,
    margin: props?.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  const color = filteredStyles.fill ?? "currentColor";
  const line = { stroke: color, strokeWidth: 1.1, strokeLinecap: "round" as const, strokeLinejoin: "round" as const };

  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      style={{ ...filteredStyles, fill: "none" }}
      className={props?.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.6" y="2.2" width="14.8" height="9.6" rx="1.3" stroke={color} strokeWidth={1.1} />
      <path d="M9 1V2.2" {...line} />
      <path d="M9 11.8V14.2M9 14.2L5.6 17M9 14.2L12.4 17" {...line} />
      <path d="M4.4 9.2L7.2 6.6L9.4 8.2L13.6 4.6" {...line} />
      <path d="M11.6 4.6H13.6V6.6" {...line} />
    </svg>
  );
}
